module.exports = __webpack_public_path__ + "img/homes-services-04.f31ce472.jpg";